import React from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from 'react-apollo'

import { checkQueryStatus } from '../../../lib/utils'
import { LoadingModal as LoadingPanel } from '../../loading/modal'
import {
  ACCOUNT_SCREENS,
  SUBSCRIPTION_STATUS
} from '../../../constants'
import ACCOUNT_QUERY_WITH_DIR from '../../../../graphql/queries/account-with-directives.gql'
import CANCEL_SURVEY_OPTIONS_QUERY from '../../../../graphql/queries/cancel-survey-options.gql'
import CancelInfo from './cancel-info'
import CancelSurvey from './cancel-survey'
import GrayLine from '../../shared/gray-line'
import styles from '../cancel-subscription.css'

function ConfirmationContent() {
  const history = useHistory()

  const accountQuery = useQuery(ACCOUNT_QUERY_WITH_DIR, {
    variables: {
      withSubscription: true,
      withClearCachedSubscriptions: true
    },
    fetchPolicy: 'network-only'
  })

  const cancelSurveyOptionsQuery = useQuery(CANCEL_SURVEY_OPTIONS_QUERY)

  if (checkQueryStatus(accountQuery) || checkQueryStatus(cancelSurveyOptionsQuery)) {
    return <LoadingPanel />
  }

  const activeSubscription = accountQuery.data?.account?.subscription
  const { status, renewalStatus } = activeSubscription || {}
  const isCancelled = [status, renewalStatus].includes(SUBSCRIPTION_STATUS.CANCELLED)

  if (!isCancelled) {
    history.push(ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.path)
  }

  return (
    <>
      <CancelInfo
        activeSubscription={activeSubscription}
        email={accountQuery.data.account?.email}
      />
      <div className={styles.section}>
        <GrayLine />
      </div>
      <CancelSurvey options={cancelSurveyOptionsQuery.data.cancelSurveyOptions} />
    </>
  )
}

export default ConfirmationContent
